<template>
  <v-card class="mx-auto">
    <v-card-title>Physical Examination on Admission</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" @submit="checkData" lazy-validation>
        <vital-sign :formData="formData"/>
        <general-survey :formData="formData"/>
        <heent :formData="formData" :config="config"/>
        <chest :formData="formData" :config="config"/>
        <heart :formData="formData" :config="config"/>
        <abdomen :formData="formData" :config="config"/>
        <guie :formData="formData" :config="config"/>
        <skin :formData="formData" :config="config"/>
        <neuro :formData="formData" :config="config"/>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="currentTab === 0"
        @click="backTab"
        color="info"
        class="mr-4 float-right">
        BACK
      </v-btn>
      <v-btn
        :disabled="!valid"
        @click="validate"
        color="success"
        class="mr-4 float-right">
        NEXT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    import Heart from "./Heart";
    import Heent from "./Heent";
    import Abdomen from "./Abdomen";
    import Chest from "./Chest";
    import GeneralSurvey from "./GeneralSurvey";
    import Guie from "./Guie";
    import Neuro from "./Neuro";
    import Skin from "./Skin";
    import VitalSign from "./VitalSign";
    import _ from 'lodash';

    export default {

        components: {
            'heart': Heart,
            'heent': Heent,
            'abdomen': Abdomen,
            'chest': Chest,
            'general-survey': GeneralSurvey,
            'guie': Guie,
            'neuro': Neuro,
            'skin': Skin,
            'vital-sign': VitalSign
        },

        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            },
        },

        data() {
            return {
                modal: false,
                valid: false,
                snackbar: false,
                config: 0,
                tab: 0,
                show: true,
                dismissible: true,
                type: 'error',
                errors: [],
            }
        },

        methods: {
            validate() {
                let vm = this;
                if (this.$refs.form.validate() && this.checkData()) {
                    this.$bus.emit('nextTab', this.currentTab + 1);
                } else {
                    _.forEach(this.errors, function (value) {
                        vm.$snotify.error(value, 'Oops!', {
                            timeout: 10000
                        });
                    });
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            },

            checkData() {
                let pe = this.formData.physical_examination;
                this.errors = [];
                if (Object.keys(pe.abdomen).length === 0) {
                    this.errors.push('Abdomen is required.');
                }
                if (Object.keys(pe.chest).length === 0) {
                    this.errors.push('Chest is required.');
                }
                if (Object.keys(pe.general_survey).length === 0) {
                    this.errors.push('General Survey is required.');
                }
                if (Object.keys(pe.guie).length === 0) {
                    this.errors.push('GU (IE) is required.');
                }
                if (Object.keys(pe.heart).length === 0) {
                    this.errors.push('Heart is required.');
                }
                if (Object.keys(pe.heent).length === 0) {
                    this.errors.push('HEENT is required.');
                }
                if (Object.keys(pe.neuro).length === 0) {
                    this.errors.push('Neurological is required.');
                }
                if (Object.keys(pe.skin).length === 0) {
                    this.errors.push('Skin/Extremities is required.');
                }
                if (Object.keys(pe.vital_sign).length === 0) {
                    this.errors.push('Vital Signs is required.');
                }

                return !this.errors.length;
            },

            getOtherConfig() {
                this.axios.get('config-other', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    this.config = response.data;
                });
            },
        },

        mounted() {
            this.getOtherConfig();
        }
    }
</script>

<style scoped>

</style>
